import {Init} from '@/core/Init'
import {Params} from '@/core/services/Params'
import {APP_EVT, APP_LEVEL, SERIES_ID, APP_USE} from '@/core/config/constants'
import {Setup} from '@/core/main/Setup'

import * as svgjs from '@svgdotjs/svg.js'

class ItemMenu {

	protected _menus: any[];
	protected _items: any[];

	constructor() {

		this._menus = Params.getMenus();
		this._items = Params.getMenuItems();

		this.drawMenu();


		if (Init.app_use == APP_USE.DESIGN) {

			this.toggleTools();

			let id: string = (Init.menu_primary_id != '') ? Init.menu_primary_id : '1';

			$('#collapse-' + id).collapse('show');

		}
	}


	toggleTools = (): void => {

		if (Init.tools_active === true) {

			$('#tool-controls').animate({top: 0}, 100, function () {
				$(this).hide();
			});

		} else {

			$('#tool-controls').show().animate({top: Setup.header_height}, 100);

		}

		Init.tools_active = !Init.tools_active;

	};


	drawMenu = (): void => {

		let text: svgjs.Text;
		let htm: string;

		for (let k of this._menus) {

			if (k.menu_key != Init._hide_menu_category) {

				htm = `<div class="card">
<div class="menu-header" id="heading-${k.menu_key}">
    <button class="accordion-header collapsed" data-bs-toggle="collapse" data-bs-target="#collapse-${k.menu_key}"
       aria-expanded="false" aria-controls="collapse-${k.menu_key}">
        ${k.menu_name}
    </button>
</div>
<div id="collapse-${k.menu_key}" class="init-collapse" aria-labelledby="heading-${k.menu_key}" data-bs-parent="#accordion">
   <div class="card-body">
        <svg class="menu-svg" id="svg-menu-${k.menu_key}"></svg>
   </div>
</div>
</div>`;

				$('#menus').append(htm);

			}
		}

		for (let i of this._items) {

			if (i.menu_key != Init._hide_menu_category) {

				let menu = svgjs.SVG('#svg-menu-' + i.menu_key) as svgjs.Container;

				try {

					let param: any = Params.getItem(i.item_id)

					let menu_svg: string = (param.menu_svg != undefined) ? param.menu_svg : param.svg_name

					let item: svgjs.Container = svgjs.SVG('#' + menu_svg).clone().addTo(menu) as svgjs.Container

					if (Init.app_use == APP_USE.DESIGN) {

						//item.transform({rotate: i.item_r, translateX: i.item_x, translateY: i.item_y, scale: i.item_s / 100})
						item.transform({originX: 0, originY: 0, translateY: i.item_y, translateX: i.item_x, rotate: i.item_r, scale: i.item_s / 100})

						if (param.item_name != '') {

							text = menu.text(i.item_name)
							text.font({family: 'Open+Sans', size: 12, anchor: 'middle'})
								.translate((i.item_x + i.label_x), (i.item_y + i.label_y + 16))

						}


						let clickclip: svgjs.Element = item.find('.clickclip')[0]

						clickclip.attr('data-item-id', param.item_id)

						clickclip.mouseover(function (this: any) {

							Init.emitter.emit(APP_EVT.MENU_ITEM_MOUSE_OVER, this.data('item-id'))

						});

						clickclip.mouseout(function (this: any) {

							Init.emitter.emit(APP_EVT.MENU_ITEM_MOUSE_OUT)

						});

						clickclip.mouseup(function (this: any) {

							Init.emitter.emit(APP_EVT.MENU_ITEM_BUTTON_CLICK, this.data('item-id'))

						});
					}
				} catch (e) {

					//console.log('error', i, e);
					//Init.reporting.report(e);

				}
			}
		}

		for (let k of this._menus) {

			if (k.menu_key != Init._hide_menu_category) {

				let menu = svgjs.SVG('#svg-menu-' + k.menu_key) as svgjs.Container;

				let bbox: svgjs.Box = menu.bbox();

				$('#svg-menu-' + k.menu_key).css('height', bbox.h + 20);
			}
		}

		if (Init.series_id == SERIES_ID.COMMERCIAL_OUTDOOR) {

			//@TODO move product-line-specific code..
			$('#collapse-4').on('shown.bs.collapse', function () {
				if (Init.active_level != APP_LEVEL.GROUND)
					Init.emitter.emit(APP_EVT.TOGGLE_ACTIVE_LEVEL, APP_LEVEL.GROUND);
			});
			//
			// //@TODO move product-line-specific code..
			$('#collapse-4').on('hidden.bs.collapse', function () {
				if (Init.active_level != APP_LEVEL.DECK)
					Init.emitter.emit(APP_EVT.TOGGLE_ACTIVE_LEVEL, APP_LEVEL.DECK);
			});

		}

		$('.init-collapse').addClass('collapse');

		// added a timer here as there is a race condition somewhere that causes a design to fail to load
		// when the app is provided with a design to load at app loading via URL querystring
		setTimeout(() => {
			Init.emitter.emit(APP_EVT.APP_READY);
		}, 250);


	}

}

export {ItemMenu};

